import React, { useEffect, useRef, useState } from "react";
import {
  startAnimation,
  endAnimation,
  animationCleanUp,
} from "../../../../animations/worldcup/alarm";

import BildGoalAlarm from "../../../frontend/templates/bild/GoalAlarm";
import anime from "animejs";
import { asyncTimeout } from "../../functions/timeout";

const AlarmTemplateBild = (props) => {
  const { showAlarm, mode, data, Template, client = "womansworldcup" } = props;
  const cardRef = useRef(null);
  useEffect(() => {
    if (showAlarm) {
      let animationStart = null;
      let animationEnd = null;
      if (showAlarm === "start" && mode === "animation") {
        animationStart = startAnimation({ client });
        anime({
          targets: cardRef.current,
          rotateX: '-180',
          duration: 1000,
          easing: 'easeInOutQuad',
        })
      }
      if (showAlarm === "end" && mode === "animation") {
        animationEnd = endAnimation({ client });
        anime({
          targets: cardRef.current,
          rotateX: '-360',
          duration: 1000,
          easing: 'easeInOutQuad',
        })
      }
      return function cleanUp() {
        if (animationStart) {
          animationCleanUp(animationStart);
        }
        if (animationEnd) {
          animationCleanUp(animationEnd);
        }
      };
    }

  }, [showAlarm, mode]);
  // if (!Template) {
  //   return;
  // }

  return (
    <div style={{
      perspective: '2500px',
      width: '2500px',
      height: '1200px'
    }}>
      <div
        className="alarm-container"
        ref={cardRef}
        style={{
          width: '1920px',
          height: '1080px',
          position: 'absolute',
          transformStyle: 'preserve-3d',
          transform: 'rotateX(0deg)',
        }}>
        <div
          className="child-template-container"
          style={{
            backfaceVisibility: 'hidden',
            WebkitBackfaceVisibility: 'hidden',
          }}
        >{props.children}</div>
        <div
          className={"template-container"}
          style={{
            backfaceVisibility: 'hidden',
            WebkitBackfaceVisibility: 'hidden',
            transform: 'rotateX(180deg)',
          }}>
          {
            data && <BildGoalAlarm data={data} mode={mode} animation={true}></BildGoalAlarm >
          }
        </div>
      </div>
    </div>
  );
};

export default AlarmTemplateBild;
